import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(theme => ({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: 24,
    overflowY: 'auto',
  },
  columns: {
    display: 'flex',
    gap: 24,
    alignItems: 'flex-start',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  leftColumn: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      flex: 'none',
    },
  },
  rightColumn: {
    width: 444,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  stateWrap: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  errorText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.mutedText,
    margin: 0,
  },
}))
